"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROW_HEAD_CELL_CATEGORY_KEY = 'base';
exports.ROW_HEAD_CELL_PARENT_COMPONENT_KEY = 'table';
exports.ROW_HEAD_CELL_COMPONENT_KEY = 'rowHeadCell';